import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDeFlag = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 50,
	height: 50,
	viewBox: "0 0 50 50",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_1339_53379)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M50.0009 19.5402H0.000976562V9.48271C0.000976562 9.00664 0.387011 8.62061 0.863084 8.62061H49.1389C49.6149 8.62061 50.001 9.00664 50.001 9.48271L50.0009 19.5402Z",
					fill: "#464655"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M49.1388 41.3795H0.863084C0.387011 41.3795 0.000976562 40.9934 0.000976562 40.5174V30.46H50.0009V40.5174C50.0009 40.9935 49.6148 41.3795 49.1388 41.3795Z",
					fill: "#FFE15A"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M50.0009 19.54H0.000976562V30.459H50.0009V19.54Z",
					fill: "#CD343C"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_1339_53379",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 50,
				height: 50,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgDeFlag);
export { ForwardRef as ReactComponent };
